import { Repeat } from 'lucide-react';

import { page, type DeclarationModule } from '@/app/moduleRegistry';

/**
 * Declaration du module Payments : abonnements mensuels vendus aux clients.
 *
 * LE LIBELLE DIT « ABONNEMENTS CLIENTS », pas « Abonnements ». Le menu des
 * parametres porte deja une entree « Abonnement » — celle de l'entreprise A
 * Astrolabe. Deux entrees homonymes dans la meme application ameneraient tot ou
 * tard quelqu'un a resilier ce qu'il ne voulait pas ; la meme collision existait
 * cote API entre les deux `AbonnementDto`, et elle y cassait la generation du
 * contrat.
 *
 * L'encaissement des factures a l'unite n'a pas d'ecran propre : il vit dans la
 * fiche de facture, la ou l'utilisateur le cherche.
 */
export const modulePayments: DeclarationModule = {
  id: 'payments',
  libelle: 'Abonnements clients',
  icone: Repeat,
  ordre: 35,

  routes: [
    {
      chemin: 'abonnements',
      estAccueil: true,
      libelleNav: 'Abonnements clients',
      composant: page(() => import('./pages/ListeAbonnementsPage')),
    },
    {
      chemin: 'abonnements/:abonnementId',
      composant: page(() => import('./pages/FicheAbonnementPage')),
    },
  ],
};
